const AiQuestionCardTestIdsScope = {
  ROOT: 'ai-question-card',
};

export const AiQuestionCardTestIds = {
  WRAPPER: `${AiQuestionCardTestIdsScope.ROOT}.wrapper`,
  PROGRESS_TEXT: `${AiQuestionCardTestIdsScope.ROOT}.progress-text`,
  PROGRESS_BAR: `${AiQuestionCardTestIdsScope.ROOT}.progress-bar`,
  QUESTION_HEADER: `${AiQuestionCardTestIdsScope.ROOT}.question-header`,
  QUESTION_TEXT: `${AiQuestionCardTestIdsScope.ROOT}.question-text`,
  SINGLE_SELECT: `${AiQuestionCardTestIdsScope.ROOT}.single-select`,
  MULTI_SELECT_OPTION: `${AiQuestionCardTestIdsScope.ROOT}.multi-select-option`,
  FREE_TEXT_INPUT: `${AiQuestionCardTestIdsScope.ROOT}.free-text-input`,
  ANSWERED_TRAIL: `${AiQuestionCardTestIdsScope.ROOT}.answered-trail`,
  ANSWERED_TRAIL_ITEM: `${AiQuestionCardTestIdsScope.ROOT}.answered-trail-item`,
  EDIT_BUTTON: `${AiQuestionCardTestIdsScope.ROOT}.edit-button`,
  BACK_BUTTON: `${AiQuestionCardTestIdsScope.ROOT}.back-button`,
  SKIP_BUTTON: `${AiQuestionCardTestIdsScope.ROOT}.skip-button`,
  CONTINUE_BUTTON: `${AiQuestionCardTestIdsScope.ROOT}.continue-button`,
  DISMISS_BUTTON: `${AiQuestionCardTestIdsScope.ROOT}.dismiss-button`,
};
